import { IDropdownOption } from '../../../types/dropdown';

export const useDropdownFilter = () => {
  return (value: string, options: IDropdownOption[], setDropdownList: (filteredList: IDropdownOption[]) => void) => {
    const filteredList = options.filter(item => {
      if (item['label'].toLowerCase().includes(value.toLowerCase())) {
        return item;
      }

      return;
    });

    setDropdownList(filteredList);
  };
};
